import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["childLinks"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CheggHomeIcon, BooksIcon, StudyIcon, WritingIcon, PrepIcon, MathSolverIcon, InternshipIcon, TestPrepIcon, CollegesIcon, MoneyIcon } from '@chegg-ui/theme';
import { NavType } from '../types';
import { logGQLErrors } from './logGQLErrors';
export var homeLink = {
  icon: CheggHomeIcon,
  text: 'Chegg home',
  href: '',
  type: NavType.home,
  loggingKey: 'home'
};
export var booksLink = {
  icon: BooksIcon,
  text: 'Books',
  href: 'books',
  type: NavType.books,
  loggingKey: 'books',
  childLinks: [{
    text: 'Rent / Buy',
    href: 'books',
    loggingKey: 'rent-buy'
  }, {
    text: 'Sell',
    href: 'sell-textbooks',
    loggingKey: 'sell'
  }]
};
export var studyLink = {
  icon: StudyIcon,
  text: 'Study',
  href: 'study',
  type: NavType.study,
  loggingKey: 'study',
  childLinks: [{
    text: 'Textbook Solutions',
    href: 'study/tbs',
    loggingKey: 'textbook-solutions'
  }, {
    text: 'Expert Q&A',
    href: 'study/qa',
    loggingKey: 'expert-qa'
  }, {
    text: 'Study Pack',
    href: 'study-pack',
    loggingKey: 'study-pack',
    visibilityCriteria: function visibilityCriteria() {
      var _data$subsEligibility, _data$subsEligibility2;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          data = _ref.data,
          error = _ref.error,
          user = _ref.user;

      /* 
        Criterias in use:
        1. Link NOT visible if GQL error
        2. Link visible for logged-out users
        3. Link visible for logged-in users with 'cspBuy' as 'true' OR 'cspUpgrade' as 'true'.
      */
      if (error) {
        logGQLErrors('Study Pack visibility criteria', error);
        return false;
      }

      if (!user) {
        return true; // show link, if user is not logged-in
      }
      /* istanbul ignore next - line ignored because of optional chaining */


      return Boolean((data === null || data === void 0 ? void 0 : (_data$subsEligibility = data.subsEligibility) === null || _data$subsEligibility === void 0 ? void 0 : _data$subsEligibility.cspBuy) || (data === null || data === void 0 ? void 0 : (_data$subsEligibility2 = data.subsEligibility) === null || _data$subsEligibility2 === void 0 ? void 0 : _data$subsEligibility2.cspUpgrade));
    }
  }, {
    text: 'Practice',
    href: 'study/v2/practice',
    loggingKey: 'practice'
  }, {
    text: 'Learn',
    href: 'learn',
    loggingKey: 'learn',
    displayNewBadge: true,
    childLinks: [{
      text: 'Physics',
      href: 'learn/physics',
      loggingKey: 'physics'
    }, {
      text: 'Chemistry',
      href: 'learn/chemistry',
      loggingKey: 'chemistry'
    }, {
      text: 'Statistics',
      href: 'learn/statistics',
      loggingKey: 'statistics'
    }, {
      text: 'Economics',
      href: 'learn/economics',
      loggingKey: 'economics'
    }, {
      text: 'Accounting',
      href: 'learn/accounting',
      loggingKey: 'accounting'
    }, {
      text: 'Computer Science',
      href: 'learn/computer-science',
      loggingKey: 'computer-science'
    }]
  }]
};
export var writingLink = {
  icon: WritingIcon,
  text: 'Writing',
  href: 'writing',
  loggingKey: 'writing',
  type: NavType.writing,
  childLinks: [{
    text: 'Dashboard',
    href: 'writing/dashboard',
    loggingKey: 'writing-dashboard'
  }, {
    text: 'Citations',
    href: 'writing/citations/dashboard',
    loggingKey: 'writing-citations'
  }, {
    text: 'Papers',
    href: 'writing/papers/dashboard',
    loggingKey: 'writing-papers'
  }, {
    text: 'Guides',
    href: 'writing/guides',
    loggingKey: 'writing-guides'
  }]
};
export var flashcardsLink = {
  icon: PrepIcon,
  text: 'Flashcards',
  href: 'flashcards',
  loggingKey: 'flashcards',
  type: NavType.flashcards,
  childLinks: [{
    text: 'Create',
    href: 'flashcards/create-flashcards',
    loggingKey: 'create'
  }, {
    text: 'My Flashcards',
    href: 'flashcards/my-flashcards',
    loggingKey: 'my-flashcards'
  }, {
    text: 'Expert Content',
    href: 'flashcards/expert-content',
    loggingKey: 'expert-content'
  }]
};
export var mathSolverLink = {
  icon: MathSolverIcon,
  text: 'Math Solver',
  href: 'math-solver',
  loggingKey: 'mathsolver',
  type: NavType['math-solver'],
  childLinks: [{
    text: 'My Solutions',
    href: 'math-solver/my-solutions',
    loggingKey: 'my-solutions'
  }, {
    text: 'Subjects',
    href: 'math-solver/subjects',
    loggingKey: 'subjects',
    childLinks: [{
      text: 'Pre Algebra Solver',
      href: 'math-solver/pre-algebra-calculator',
      loggingKey: 'pre-algebra-solver'
    }, {
      text: 'Algebra Solver',
      href: 'math-solver/algebra-calculator',
      loggingKey: 'algebra-solver'
    }, {
      text: 'Pre Calculus Solver',
      href: 'math-solver/pre-calculus-calculator',
      loggingKey: 'pre-calculus-solver'
    }, {
      text: 'Calculus Solver',
      href: 'math-solver/calculus-calculator',
      loggingKey: 'calculus-solver'
    }, {
      text: 'Linear Algebra Solver',
      href: 'math-solver/linear-algebra-calculator',
      loggingKey: 'linear-algebra-solver'
    }]
  }, {
    text: 'Graphing',
    href: 'math-solver/graphing-calculator',
    loggingKey: 'graphing'
  }]
};
export var internshipsLink = {
  icon: InternshipIcon,
  text: 'Internships',
  href: 'internships',
  loggingKey: 'internships',
  type: NavType.internships,
  childLinks: [{
    text: 'Internships & jobs',
    href: 'internships',
    loggingKey: 'internships-jobs'
  }, {
    text: 'Career profiles',
    href: 'career-center/explore',
    loggingKey: 'career-profiles'
  }, {
    text: 'Advice',
    href: 'advice/career-center',
    loggingKey: 'advice'
  }]
};
export var testPrepLink = {
  icon: TestPrepIcon,
  text: 'Test Prep',
  href: 'test-prep',
  loggingKey: 'testprep',
  type: NavType['test-prep'],
  childLinks: [{
    text: 'ACT',
    href: 'test-prep/act',
    loggingKey: 'act',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/act',
      loggingKey: 'act-prep-options'
    }, {
      text: 'Tutors',
      href: 'tutors/ACT-online-tutoring',
      loggingKey: 'act-tutors'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/act',
      loggingKey: 'act-free-resources'
    }]
  }, {
    text: 'SAT',
    href: 'test-prep/sat',
    loggingKey: 'sat',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/sat',
      loggingKey: 'sat-prep-options'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/sat',
      loggingKey: 'sat-free-resources'
    }]
  }, {
    text: 'GRE',
    href: 'test-prep/gre',
    loggingKey: 'gre',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/gre',
      loggingKey: 'gre-prep-options'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/gre',
      loggingKey: 'gre-free-resources'
    }]
  }, {
    text: 'GMAT',
    href: 'test-prep/gmat',
    loggingKey: 'gmat',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/gmat',
      loggingKey: 'gmat-prep-options'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/gmat',
      loggingKey: 'gmat-free-resources'
    }]
  }, {
    text: 'MCAT',
    href: 'test-prep/mcat',
    loggingKey: 'mcat',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/mcat',
      loggingKey: 'mcat-prep-options'
    }, {
      text: 'Tutors',
      href: 'tutors/MCAT-online-tutoring',
      loggingKey: 'mcat-tutors'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/mcat',
      loggingKey: 'mcat-free-resources'
    }]
  }, {
    text: 'LSAT',
    href: 'test-prep/lsat',
    loggingKey: 'lsat',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/lsat',
      loggingKey: 'lsat-prep-options'
    }, {
      text: 'Tutors',
      href: 'tutors/LSAT-online-tutoring',
      loggingKey: 'lsat-tutors'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/lsat',
      loggingKey: 'lsat-free-resources'
    }]
  }, {
    text: 'NCLEX-RN',
    href: 'test-prep/nclex-rn',
    loggingKey: 'nclex-rn',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/nclex-rn',
      loggingKey: 'nclex-rn-prep-options'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/nclex-rn',
      loggingKey: 'nclex-rn-free-resources'
    }]
  }, {
    text: 'NCLEX-PN',
    href: 'test-prep/nclex-pn',
    loggingKey: 'nclex-pn',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/nclex-pn',
      loggingKey: 'nclex-pn-prep-options'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/nclex-pn',
      loggingKey: 'nclex-pn-free-resources'
    }]
  }, {
    text: 'AP',
    href: 'test-prep/ap',
    loggingKey: 'ap',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/ap',
      loggingKey: 'ap-prep-options'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/ap',
      loggingKey: 'ap-free-resources'
    }]
  }, {
    text: 'ASVAB',
    href: 'test-prep/asvab',
    loggingKey: 'asvab',
    childLinks: [{
      text: 'Prep options',
      href: 'test-prep/asvab',
      loggingKey: 'asvab-prep-options'
    }, {
      text: 'Free resources',
      href: 'test-prep/free-resources/asvab',
      loggingKey: 'asvab-free-resources'
    }]
  }]
};
export var scholarshipsLink = {
  icon: CollegesIcon,
  text: 'Scholarships',
  href: 'scholarships',
  loggingKey: 'scholarships',
  type: NavType.scholarships,
  childLinks: [{
    text: 'Scholarships',
    href: 'scholarships',
    loggingKey: 'scholarships'
  }, {
    text: 'Explore colleges',
    href: 'schools',
    loggingKey: 'explore'
  }, {
    text: 'My college list',
    href: 'admissions/college-list',
    loggingKey: 'my-list'
  }]
};
export var moneyLink = {
  icon: MoneyIcon,
  text: 'Money',
  href: 'money',
  loggingKey: 'money',
  type: NavType.money,
  childLinks: [{
    text: 'Expert advice',
    href: 'money#moneymoments',
    loggingKey: 'moneymoments'
  }, {
    text: 'Watch series',
    href: 'money/videos',
    loggingKey: 'moneyvideos',
    childLinks: [{
      text: 'Going From Broke',
      href: 'goingfrombroke',
      loggingKey: 'goingfrombroke'
    }]
  }, {
    text: "Money Q's",
    href: 'money/money-questions',
    loggingKey: 'moneyquestions'
  }, {
    text: 'Calculators',
    href: 'money/calculators',
    loggingKey: 'calculators'
  }]
};
export var facultyLink = {
  icon: CollegesIcon,
  // TODO: unclear what this should be, if it even matters
  text: 'Faculty',
  href: 'faculty',
  loggingKey: 'faculty',
  type: NavType.faculty,
  childLinks: []
};
export var standardLinkSet = [homeLink, booksLink, studyLink, writingLink, flashcardsLink, mathSolverLink, internshipsLink, scholarshipsLink, moneyLink];
var mainNavLinks = {
  home: standardLinkSet,
  books: standardLinkSet,
  study: standardLinkSet,
  writing: standardLinkSet,
  flashcards: standardLinkSet,
  'math-solver': standardLinkSet,
  internships: standardLinkSet,
  'test-prep': standardLinkSet,
  scholarships: standardLinkSet,
  money: standardLinkSet,
  faculty: standardLinkSet,
  uversity: standardLinkSet
};
/**
 * Use this to filter out NavigationLink / NavigationSubLink based on the `visibilityCriteria` field present in the `links` parameter.
 * @param links Pass object of type `NavigationLinkKind[]`
 * @param args Eligibility criteria derived from current navLink type and `useEligibility` hook
 * @returns filtered out `NavigationLinkKind[]`
 * */

export function getVisibleLinks(links, args) {
  return links.map(function (_ref2) {
    var childLinks = _ref2.childLinks,
        m = _objectWithoutProperties(_ref2, _excluded);

    var isValidated = m.visibilityCriteria ? m.visibilityCriteria(args) : true;
    return isValidated ? _objectSpread(_objectSpread({}, m), {}, {
      childLinks: childLinks ? childLinks.filter(function (f) {
        return f.visibilityCriteria ? f.visibilityCriteria(args) : true;
      }) : undefined
    }) : null;
  }).filter(Boolean);
} // This api is set up in such a way as to very simply allow a configuration prop similar to the center links API if needed

export default mainNavLinks;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/shared/mainNavLinks.js
// module id = 692
// module chunks = 11